const ASSET_MANAGEMENT_TYPES = [{
  label: 'Asset Register',
  value: 1,
  key: 1,
  icon: 'EpicFilled', // Register as foundational = Epic
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Asset Tracking',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Tracking progress/story
  color: '#43a047',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Maintenance Log',
  value: 3,
  key: 3,
  icon: 'BugFilled', // Maintenance often involves fixing bugs/issues
  color: '#fb8c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Warranty Info',
  value: 4,
  key: 4,
  icon: 'SupportFilled', // Warranty closely linked to support
  color: '#7b1fa2',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Asset Disposal',
  value: 5,
  key: 5,
  icon: 'TaskFilled', // Disposal as a defined task
  color: '#6d4c41',
  background: 'rgba(215,204,200,0.16)'
}, {
  label: 'Depreciation',
  value: 6,
  key: 6,
  icon: 'ImprovementsFilled', // Related to value tracking/adjustment
  color: '#37474f',
  background: 'rgba(176,190,197,0.16)'
}, {
  label: 'Asset Audit',
  value: 7,
  key: 7,
  icon: 'FeatureRequestFilled', // Direct match or can create if not in KO set
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}];

export { ASSET_MANAGEMENT_TYPES };
